import { useEffect, useState } from "react";
import api from "@/lib/api";
import { FlaskConical, Radio } from "lucide-react";

let cached = null;
// Environment badge. Preview: loud amber pill everywhere. Production: subtle LIVE pill only where showLive is set.
export default function EnvBadge({ showLive = false, className = "" }) {
  const [env, setEnv] = useState(cached);
  useEffect(() => { if (!cached) api.get("/env").then((r) => { cached = r.data; setEnv(r.data); }).catch(() => {}); }, []);
  if (!env) return null;
  if (env.environment === "preview") {
    return <span className={`inline-flex items-center gap-1 rounded-full border border-amber-500/60 bg-amber-400 text-amber-950 text-[10px] font-extrabold tracking-wider px-2 py-0.5 shadow-sm whitespace-nowrap ${className}`} title="You are using the Preview / Sandbox environment" data-testid="env-badge-preview"><FlaskConical className="w-3 h-3" /> PREVIEW / SANDBOX</span>;
  }
  if (!showLive) return null;
  return <span className={`inline-flex items-center gap-1 rounded-full border border-border bg-secondary text-muted-foreground text-[10px] font-semibold tracking-wider px-2 py-0.5 ${className}`} title="Live / Production environment" data-testid="env-badge-live"><Radio className="w-3 h-3" /> LIVE</span>;
}
